export default async function useFindVariant(productId: string, options: any) {
    const { data } = await useFetch('/api/findVariant', {
        method: 'POST',
        body: JSON.stringify({ options, productId }),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return data.value.variantId;
}
